import React from "react";
import { Radio } from "antd";
import CustomTypography from "../../../commonComponents/CustomTypography";

const DepartmentListItem = ({ department, selected, onSelect }) => {
  const handleClick = () => {
    onSelect(department.id);
  };

  return (
    <div
      onClick={handleClick}
      className={`flex items-center justify-between p-4 rounded-lg cursor-pointer transition-all ${
        selected
          ? "bg-[#E6F4FF] border border-solid border-[#91CAFF]"
          : "bg-white hover:bg-[#F5F5F5]"
      }`}
    >
      <div className="flex items-center gap-3 flex-1">
        <Radio checked={selected} />
        <CustomTypography.Body className="!text-black !font-normal">
          {department.name}
        </CustomTypography.Body>
      </div>
    </div>
  );
};

export default DepartmentListItem;
